import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "bf-contact-form-region" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "bf-heading-display" }, "Kon­takt­for­mu­lar", -1)
const _hoisted_4 = {
  key: 0,
  class: "my-3"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-3x fa-spin fa-spinner" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "bf-heading-script mt-4" }
const _hoisted_8 = { class: "bf-region-parks mb-2" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Du kannst mir alternativ auch eine E-Mail an ")
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" schreiben.")
const _hoisted_12 = { class: "fa fa-fw fa-spinner fa-spin ml-1" }
const _hoisted_13 = {
  type: "submit",
  class: "d-none"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center text-success mt-4 mb-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-square fa-4x" }),
  /*#__PURE__*/_createElementVNode("div", { class: "h3 ps-3" }, [
    /*#__PURE__*/_createElementVNode("div", null, "Vielen Dank für deine Nachricht!"),
    /*#__PURE__*/_createElementVNode("div", null, "Ich werde mich schnellstmöglich bei dir zurückmelden.")
  ])
], -1)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.success)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
          novalidate: ""
        }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
              : (_ctx.region && _ctx.region?.manager)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.region?.manager.full_name), 1),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("b", null, "Gebietsleiterin " + _toDisplayString(_ctx.region?.name), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_9,
                      _createElementVNode("b", null, [
                        _createElementVNode("a", {
                          href: 'mailto:' + _ctx.region?.manager.email
                        }, _toDisplayString(_ctx.region?.manager.email), 9, _hoisted_10)
                      ]),
                      _hoisted_11
                    ])
                  ], 64))
                : _createCommentVNode("", true)
          ]),
          _createVNode(_component_TextField, {
            class: "mb-3",
            field: "name",
            errors: _ctx.errors,
            modelValue: _ctx.form.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
            label: "Dein Name*",
            prefix: "contact-form-region"
          }, null, 8, ["errors", "modelValue"]),
          _createVNode(_component_TextField, {
            class: "mb-3",
            field: "email",
            errors: _ctx.errors,
            modelValue: _ctx.form.email,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event)),
            label: "E-Mail-Adresse*",
            prefix: "contact-form-region"
          }, null, 8, ["errors", "modelValue"]),
          _createVNode(_component_TextField, {
            class: "mb-3",
            field: "phone",
            errors: _ctx.errors,
            modelValue: _ctx.form.phone,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.phone) = $event)),
            label: "Telefonnummer",
            prefix: "contact-form-region"
          }, null, 8, ["errors", "modelValue"]),
          _createVNode(_component_TextField, {
            class: "mb-4",
            type: "textarea",
            field: "text",
            errors: _ctx.errors,
            modelValue: _ctx.form.text,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.text) = $event)),
            label: "Nachricht*",
            prefix: "contact-form-region"
          }, null, 8, ["errors", "modelValue"]),
          _createElementVNode("a", {
            href: "#",
            class: "btn btn-primary",
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
          }, [
            _createTextVNode(_toDisplayString(_ctx.region?.manager.prename) + " kontaktieren ", 1),
            _withDirectives(_createElementVNode("i", _hoisted_12, null, 512), [
              [_vShow, _ctx.loading]
            ])
          ]),
          _createElementVNode("button", _hoisted_13, _toDisplayString(_ctx.region?.manager.prename) + " kontaktieren", 1)
        ], 32))
      : (_ctx.success)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
        : _createCommentVNode("", true)
  ]))
}